export interface PasscodeResetRequest {
  DeviceName: string;
  DeviceID: string;
  RequestID: string;
  Approved: boolean;
}

export type PasscodeResetsPendingResponse = PasscodeResetRequest[];

export interface DeviceV1 {
  DeviceDesc: string;
  DeviceID: string;
  Modified: string;
  DeletedAt?: string;
}

export type DevicesV1ConnectedResponse = DeviceV1[];

export interface ProfileDeviceV1 {
  deviceId: string;
  deviceType: string;
  verified: boolean;
  registeredAt: string;
}

export type ProfileV1ConnectedResponse = {
  isTabletOwner: boolean;
  devices: ProfileDeviceV1[];
};

export type IntegrationListResponse = {
  integrations: Integration[];
};

export type Integration = {
  name: string;
  id: string;
  provider: string;
  added: string;
  issues?: IntegrationIssue[] | null;
  providerType: ProviderType;
};

export enum IntegrationIssueType {
  PROVIDER_REVOKED_ACCESS = 'providerRevokedAccess',
  NO_CONNECT = 'noConnect',
  NO_ACCESSIBLE_CALENDAR = 'noAccessibleCalendar',
  ADMIN_APPROVAL = 'adminApproval',
  POLICY_RESTRICTION = 'policyRestriction',
}

export type IntegrationIssue = {
  type: IntegrationIssueType;
  transient: boolean;
  level: string;
  timestamp: string;
  messages: IntegrationIssueMessage[];
};

export type IntegrationIssueMessage = {
  locale: string;
  text: string;
};

export type IntegrationToSave = {
  state: string;
  scope?: string;
  code: string;
  name?: string;
};

export type IntegrationSaveRequest = {
  integration: IntegrationToSave;
  subPath: string;
};

export type ProviderType = 'Messaging' | 'Storage' | 'Calendar';

export type ProviderDetails = {
  displayName: string;
  typeName: string;
  subPath: string;
  iconId: string;
  /** Integration category **/
  providerType: ProviderType;
  /** `true` if the provider requires Connect in order to be enabled **/
  subscription?: boolean;
  labels?: string[];
  description?: string;
};

export type ProviderAuthURIResponse = string;

export type IntegrationTermsOfServiceStatusResponse = {
  version: number;
  acceptedDate: string;
} | null;

export type IntegrationExceptionType = 'ALREADY_ADDED' | 'ACCOUNT_MISMATCH';

export class IntegrationException extends Error {
  constructor(public type: IntegrationExceptionType) {
    super(type);
  }
}

export enum ClientType {
  RM10 = 'RM10',
  RM11 = 'RM11',
  RM02 = 'RM02',
  RM03 = 'RM03',
  RM12 = 'RM12',
  Browser = 'browser',
  Mobile = 'mobile',
  Desktop = 'desktop',
  Unknown = 'unknown',
}

export enum ClientSource {
  DeviceV1 = 'deviceV1',
  ProfileV1 = 'profileV1',
}

export interface ClientInformation {
  clientName: string;
  clientId: string;
  clientType: ClientType;
  clientSource: ClientSource;
  // Both timestamps below are ISO strings because we loose precision converting to a Date object
  // Since the devicesV1 deletion endpoint requires an exact registeredAt timestamp to match, we
  // cannot tolerate a loss in precision.
  registeredAt: string;
  deletedAt: string | null;
}
